// extracted by mini-css-extract-plugin
export var bodyRow = "_gi-d";
export var cardColumns = "_gi-e";
export var ellipsesOverflow = "_gi-2";
export var flatBottomCorners = "_gi-3";
export var flatTopCorners = "_gi-4";
export var headerActionsDropdown = "_gi-f";
export var headerBottomRow = "_gi-c";
export var headerTopRow = "_gi-b";
export var orderDetailsWrapper = "_gi-0";
export var orderInfoContainer = "_gi-1";
export var productDetails = "_gi-9";
export var productImage = "_gi-5";
export var responsiveTable = "_gi-8";
export var shipmentContainer = "_gi-a";
export var tableBottomLeft = "_gi-6";
export var tableBottomRight = "_gi-7";
export var trackingLink = "_gi-g";